<template>
    <ValidationObserver ref="validation">
        <label for="contact">{{ $t('Contact data')}}</label>
        <fieldset id="contact">
            <div class="form-row">
                <div class="form-group col-md-6">
                    <label class="sr-only" for="firstName">{{ $t('First name') }}</label>
                    <ValidationProvider v-slot="{ errors, classes, ariaMsg, ariaInput }" rules="required" vid="firstName">
                        <div class="input-group">
                            <div class="input-group-prepend">
                                <div class="input-group-text"><i class="fa fa-user"></i></div>
                            </div>
                            <input id="firstName" v-model="firstName" v-bind="ariaInput" :class="classes" :placeholder="$t('First name')"
                                   class="form-control" type="text" @change="updateFirstName"/>
                            <span v-bind="ariaMsg" class="invalid-feedback">{{ errors[0] }}</span>
                        </div>
                    </ValidationProvider>
                </div>
                <div class="form-group col-md-6">
                    <label class="sr-only" for="lastName">{{ $t('Last name') }}</label>
                    <ValidationProvider v-slot="{ errors, classes, ariaMsg, ariaInput }" rules="required" vid="lastName">
                        <div class="input-group">
                            <div class="input-group-prepend">
                                <div class="input-group-text"><i class="fa fa-user"></i></div>
                            </div>
                            <input id="lastName" v-model="lastName" v-bind="ariaInput" :class="classes" :placeholder="$t('Last name')"
                                   class="form-control" type="text" @change="updateLastName"/>
                            <span v-bind="ariaMsg" class="invalid-feedback">{{ errors[0] }}</span>
                        </div>
                    </ValidationProvider>
                </div>
            </div>
        </fieldset>
        <label for="organisationData">{{ $t('Organisation data')}}</label>
        <fieldset id="organisationData">
            <div class="form-row">
                <div class="form-group col-md-6">
                    <div class="input-group">
                        <label class="sr-only" for="organisation">{{ $t('Organisation') }}</label>
                        <div class="input-group-prepend"><div class="input-group-text"><i class="fa fa-sitemap"></i></div></div>
                        <select2 id="organisation" v-model="organisationId" class="form-control" @change="updateOrganisation" :options="organisations">
                            <option :value="null" selected="selected">
                                {{ $t('Personal shipment') }}
                            </option>
                        </select2>
                    </div>
                </div>
            </div>
        </fieldset>
        <div v-show="organisationId" class="form-row">
            <div class="form-group col-md-6">
                <label class="sr-only" for="project">{{ $t('Project') }}</label>
                <ValidationProvider v-slot="{ errors, classes, ariaMsg, ariaInput }" rules="required" vid="project">
                    <div class="input-group">
                        <div class="input-group-prepend">
                            <div class="input-group-text"><i class="fa fa-project-diagram"></i></div>
                        </div>
                        <input id="project" v-model="project" v-bind="ariaInput" :class="classes" :placeholder="$t('Project')" :required="true"
                               class="form-control" type="text" @change="updateProject"/>
                        <span v-bind="ariaMsg" class="invalid-feedback">{{ errors[0] }}</span>
                    </div>
                </ValidationProvider>
            </div>
        </div>
    </ValidationObserver>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import Select2 from "../Select2";

export default {
    name: "RequesterForm",
    components: {Select2, ValidationProvider, ValidationObserver },
    data() {
        let store = this.$store.state.order.requester;
        return {
            organisationId: store.organisation ? store.organisation.id : undefined,
            project: store.project,
            firstName: store.firstName,
            lastName: store.lastName,
        }
    },
    computed: {
        errors() {
            return this.$refs.validation ? this.$refs.validation.$data.errors : undefined;
        },
        organisations() {
            return this.$store.state.order.requester.organisations;
        },
        organisation() {
            return this.organisations.filter(organisation => organisation.id === this.organisationId).shift();
        },
    },
    methods: {
        updateFirstName() {
            this.$store.commit('order/requester/setFirstName', this.errors.firstName.length ? undefined : this.firstName);
        },
        updateLastName() {
            this.$store.commit('order/requester/setLastName', this.errors.lastName.length ? undefined : this.lastName);
        },
        updateOrganisation() {
            this.$store.commit('order/requester/setOrganisation', this.organisation);

            if (!this.organisation) {
                this.project = undefined;
                this.updateProject();
            }
        },
        updateProject() {
            this.$store.commit('order/requester/setProject', this.errors.project.length ? undefined : this.project);
        },
    },
    mounted() {
        this.$store.dispatch("order/requester/loadOrganisations");
    },
}
</script>
